package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.layout.appHeaderHorizontalPadding
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.footer_privacy
import portalvv.shared.generated.resources.footer_rights
import portalvv.shared.generated.resources.footer_year
import portalvv.shared.generated.resources.logo_vv

@Composable
actual fun AppFooter() {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier =
                Modifier
                    .fillMaxWidth()
                    .height(64.dp)
                    .padding(horizontal = appHeaderHorizontalPadding(maxWidth)),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.CenterHorizontally),
        ) {
            Image(
                painter = painterResource(Res.drawable.logo_vv),
                contentDescription = null,
                modifier = Modifier.width(108.dp).height(20.dp),
            )
            val onOpenPrivacy = LocalOpenPrivacyPolicy.current
            Text(
                text = "${stringResource(Res.string.footer_year)} · ${stringResource(Res.string.footer_rights)}",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = "·",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = stringResource(Res.string.footer_privacy),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                textDecoration = TextDecoration.Underline,
                modifier = Modifier.clickable { onOpenPrivacy() },
            )
        }
    }
}
